<template>
  <div class="sku-info-header__wrapper">
    <div class="sku-base-info__wrapper">
      <div class="sku-img__wrapper">
        <div>
          <el-image
            :src="
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg'
            "
            :preview-src-list="[
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg',
            ]"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic-square.jpg" />
            </div>
          </el-image>
        </div>
      </div>
      <div class="info__wrapper">
        <el-descriptions
          class="border-detail-main-form"
          border
          size="small"
          :column="2"
        >
          <el-descriptions-item
            :label="$l('label_eenc_SkuNo') || 'SkuNo'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '240px' }"
          >
            {{ formData.evgSkuNo || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('label_eenc_status') || '状态'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '139px' }"
          >
            <b-badge
              style="font-size: 12px"
              :variant="
                formData.evgSkuStatus === 'Y'
                  ? 'success'
                  : formData.evgSkuStatus === 'D'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{ formData.v_evgSkuStatus }}
            </b-badge>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          border
          class="border-detail-main-form"
          size="small"
          :column="2"
        >
          <el-descriptions-item
            :labelStyle="{ minWidth: '100px', maxWidth: '100px' }"
            :contentStyle="{ maxWidth: '479px', minWidth: '479px' }"
            :label="$l('label_eenc_ch_name') || '中文名称'"
          >
            {{ formData.goodsName || '' }}
            <br />
            {{ formData.goodsNameEn || '' }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions
          border
          size="small"
          class="border-detail-main-form"
          :column="2"
        >
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '240px' }"
            :label="$l('label_eenc_category') || '分类'"
          >
            {{ formData.categoryFullName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '139px' }"
            :label="$l('label_eenc_is_vc') || 'VC产品'"
          >
            <el-tag
              v-if="formData.isVc"
              size="mini"
              effect="dark"
              :type="formData.isVc == 'Y' ? 'warning' : ''"
            >
              {{ formData.v_isVc }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions border size="small" :column="2">
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '240px' }"
            :label="$l('label_eenc_brand') || '品牌'"
          >
            {{ formData.brandName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '139px' }"
            :label="$l('label_eenc_collection') || '系列'"
          >
            {{ formData.collectionName || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="div_title mt-3 mb-3">
      {{ $l('form_label_productcoding') || '产品赋码' }}
    </div>
    <el-form
      ref="form"
      size="mini"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_eenc_ncNo') || 'NC产品编号'"
            prop="ncNo"
          >
            <el-input
              v-model="formData.ncNo"
              :placeholder="$l('placeholder_eenc_ncNo') || '请输入NC产品编号'"
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_eenc_scmCode') || '成品工厂(默认)'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
              :selectedLabel.sync="formData.scmName"
              :placeholder="$l('placeholder_eenc_scmCode') || '请选择成品工厂'"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_eenc_ftyPrice') || '工厂单价'"
            prop="ftyPrice"
          >
            <el-input-number
              v-model="formData.ftyPrice"
              :controls="false"
              :step="1"
              :min="0"
              :max="9999999999999"
              :precision="3"
              :placeholder="$l('placeholder_eenc_ftyPrice') || '请输入工厂单价'"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_currencyUnit') || '货币单位'"
            prop="ftyPriceCurrencyUnit"
          >
            <dict-select
              v-model="formData.ftyPriceCurrencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="
                $l('INDEX.form_placeholder_currencyUnit') || '请选择货币单位'
              "
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_eenc_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.buyerName"
              :placeholder="$l('placeholder_eenc_buyer') || '请选择采购人员'"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_eenc_ftyLeadTime') || '生产周期(天)'"
            prop="ftyLeadTime"
          >
            <el-input-number
              v-model="formData.ftyLeadTime"
              :controls="false"
              :step="1"
              :min="0"
              :max="999999999"
              :precision="0"
              :placeholder="$l('placeholder_eenc_ftyLeadTime') || '请输入生产周期'"
              style="width:100%"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SpecDetailTable
      class="mt-1"
      :evgSkuCode="evgSkuCode"
      :ncNo="formData.ncNo"
      :disabled="formData.skuPackSize == 'single'"
      ref="itemTable"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import SpecDetailTable from '../spec-detail-table'

export default {
  mixins: [EditLoading],
  components: { SpecDetailTable },
  props: {
    disabled: { type: Boolean, default: false },
    productLine: { type: String, default: '' },
    evgSkuCode: { type: String, default: '' },
    baseInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {},
      visible: false,
      dynamicFormData: {},
      rules: {
        ftyPrice: [
          {
            required: true,
            message: this.$l('rules_eenc_ftyPrice') || '请输入工厂单价',
            trigger: ' blur',
          },
        ],
        ftyPriceCurrencyUnit: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_currencyUnit') ||
              '请选择货币单位',
            trigger: ' blur',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('rules_eenc_scm') || '请选择工厂',
            trigger: ' blur',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('rules_eenc_buyer') || '请选择采购人员',
            trigger: ' blur',
          },
        ],
        ncNo: [
          {
            required: true,
            message: this.$l('rules_eenc_ncNo') || '请输入NC产品编号',
            trigger: ' blur',
          },
        ],
      },
    }
  },
  watch: {},
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getData()
    },
    async getData() {
      if (!this.evgSkuCode) return
      const res = await this.$api
        .ecomEvgSkuNcDetailApi({
          evgSkuCode: this.evgSkuCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },

    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },

    async confirm() {
      const result = await this.formValidate()
      if (!result) return

      const sepcList = this.$refs.itemTable.getTableData()
      if (!sepcList || !sepcList.length) {
        this.$message.warning(
          this.$l('form_label_Pleaseprovide') || '请补充产品规格明细'
        )
        return
      }

      this.loadingOpen()
      const params = {
        ...this.formData,
        evgSkuCode: this.evgSkuCode,
        sepcList,
      }
      const res = await this.$api
        .ecomEvgSkuNcSaveApi({ ...params })
        .catch(() => null)

      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      this.$emit('close')
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.sku-info-header__wrapper {
  background-color: white;
  overflow: hidden;
  .sku-base-info__wrapper {
    display: flex;
    align-items: stretch;

    .info__wrapper {
      flex: 1;
      height: auto;
    }
    .sku-img__wrapper {
      width: 131px;
      border: 1px solid #e8e8e8;
      border-right: 0px;
      display: flex;
      justify-content: center;
      align-items: self-start;
      .el-image {
        margin-top: 9px;
        width: 100px;
        height: 100px;
      }
    }
  }
}

.div_title {
  color: #2b3447;
  font-size: 16px;
  font-weight: 600;
}

::v-deep {
  .el-descriptions--small.is-bordered .el-descriptions-item__cell {
    padding: 10px 10px !important;
  }
  .border-detail-main-form {
    .el-descriptions-item__cell {
      border-bottom: 0px !important;
    }
  }
}
</style>
